module.exports = __webpack_public_path__ + "static/media/halfcircle_pink.ffc7305b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neonat/halfcircle_pink.jpg
// module id = 957
// module chunks = 1